document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap === "undefined") {
    // eslint-disable-next-line no-console
    console.warn("GSAP not loaded");
    return;
  }

  const scrollTriggerAvailable =
    typeof ScrollTriggerUtils !== "undefined" && ScrollTriggerUtils.register();

  const testingSection = document.querySelector(".enterprise-testing-section");
  const imageWrapper = document.querySelector(
    ".enterprise-testing-section__image-wrapper"
  );
  const cursors = document.querySelectorAll(
    ".enterprise-testing-section__cursor"
  );
  const image = document.querySelector(".enterprise-testing-section__image");

  if (!testingSection || !imageWrapper || cursors.length === 0 || !image) {
    return;
  }

  // Start positions
  const cursor1StartPos = { left: -10, top: 15 };
  const cursor2StartPos = { right: 15, top: 5 };
  const cursor3StartPos = { left: 40, bottom: 10 };
  const startPositions = [cursor1StartPos, cursor2StartPos, cursor3StartPos];

  // End positions
  const cursor1EndPos = { left: 5, top: 20 };
  const cursor2EndPos = { right: 30, top: 18 };
  const cursor3EndPos = { left: 48, bottom: 20 };
  const endPositions = [cursor1EndPos, cursor2EndPos, cursor3EndPos];

  // Scroll trigger positions
  const scrollStartPositions = ["top 60%", "top 62%", "top 58%"];
  const scrollEndPositions = ["top 20%", "top 18%", "top 22%"];

  // Rotation values
  const initialRotations = [-15, 10, -8];

  function calculatePosition(pos, width, height) {
    let x, y;

    if (pos.left !== undefined) {
      x = (width * pos.left) / 100;
    } else if (pos.right !== undefined) {
      x = width - (width * pos.right) / 100;
    } else {
      x = width / 2;
    }

    if (pos.top !== undefined) {
      y = (height * pos.top) / 100;
    } else if (pos.bottom !== undefined) {
      y = height - (height * pos.bottom) / 100;
    } else {
      y = height / 2;
    }

    return { x, y };
  }

  function initAnimations() {
    const wrapperRect = imageWrapper.getBoundingClientRect();
    const wrapperCenterX = wrapperRect.width / 2;
    const wrapperCenterY = wrapperRect.height / 2;

    cursors.forEach((cursor, index) => {
      const startPos = startPositions[index];
      const endPos = endPositions[index];

      const start = calculatePosition(
        startPos,
        wrapperRect.width,
        wrapperRect.height
      );
      const end = calculatePosition(
        endPos,
        wrapperRect.width,
        wrapperRect.height
      );

      const startOffsetX = start.x - wrapperCenterX;
      const startOffsetY = start.y - wrapperCenterY;
      const endOffsetX = end.x - wrapperCenterX;
      const endOffsetY = end.y - wrapperCenterY;

      const moveX = endOffsetX - startOffsetX;
      const moveY = endOffsetY - startOffsetY;

      const initialRotation = initialRotations[index] || 0;
      const scaleX = index === 0 || index === 2 ? -1 : 1;

      if (scrollTriggerAvailable) {
        gsap.set(cursor, {
          opacity: 0,
          scale: 0.85,
          scaleX,
          x: startOffsetX,
          y: startOffsetY,
          rotation: initialRotation,
        });

        gsap.to(cursor, {
          opacity: 1,
          scale: 1,
          scaleX,
          x: startOffsetX + moveX,
          y: startOffsetY + moveY,
          rotation: initialRotation * 0.3,
          ease: "power2.out",
          scrollTrigger: {
            trigger: testingSection,
            start: scrollStartPositions[index] || "top 60%",
            end: scrollEndPositions[index] || "top 20%",
            scrub: 1.2,
            invalidateOnRefresh: true,
          },
        });
      } else {
        gsap.set(cursor, {
          opacity: 1,
          scale: 1,
          scaleX,
          x: endOffsetX,
          y: endOffsetY,
          rotation: initialRotation * 0.3,
        });
      }
    });
  }

  if (image.complete) {
    initAnimations();
  } else {
    image.addEventListener("load", initAnimations, { once: true });
  }
});
